import React from 'react';
import { Flex, Progress } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectList,
  selectPageNo,
  selectPageSize,
  selectSearch,
} from '../../Redux/Plan/selector';
import { actions } from '../../Redux/Plan/slice';
import PlanList from 'views/Plan/PlanList';

function List() {
  const data = useSelector(selectList);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const search = useSelector(selectSearch);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(actions.doGetList());
  }, [pageNo, pageSize, search]);

  return (
    <Flex direction="column" pt={{ sm: '125px', lg: '75px' }}>
      <Card backgroundColor={'#21232E'} boxShadow={'none'} borderRadius={'6px'}>
        <PlanList data={data} />
      </Card>
    </Flex>
  );
}

export default List;
